<template>
  <div style="width:100%;overflow-y:auto;overflow-x:hidden;height:100%;">
    <div style="padding:0px;width:100%;">
      <div style="width:235px;float: left;" class="whiteBox searchbox">
        <h4><i class="el-icon-d-arrow-right"></i> 筛选条件</h4>
        <div class="filter-container search-box">
          <el-form label-position="top" label-width="80px">
            <el-form-item label="搜索">
              <el-input
                size="mini"
                style="width:180px;top:2px;"
                placeholder="姓名或手机号"
                v-model="searchQuery.key"
              ></el-input>
            </el-form-item>
            <el-form-item label="线索来源">
              <el-select
                size="mini"
                style="width:180px;"
                v-model="searchQuery.fromType"
              >
                <el-option label="全部" :value="0"></el-option>
                <el-option label="线上" :value="1"></el-option>
                <el-option label="线下" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="成员" v-if="members.length > 1">
              <el-select
                size="mini"
                style="width:180px;"
                multiple
                v-model="searchQuery.member"
              >
                <el-option
                  v-for="item in members"
                  :key="item.memberId"
                  :label="item.userName"
                  :value="item.memberId"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="车系">
              <el-select size="mini" style="width:180px;" multiple v-model="searchQuery.series">
                <el-option
                  v-for="item in carOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>-->
            <el-form-item label="完成时间" v-if="filterType === 2">
              <el-date-picker
                v-model="searchQuery.followDateRange"
                type="daterange"
                size="mini"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-form>
          <div style="margin-top:20px;">
            <el-button
              size="small"
              icon="el-icon-search"
              class="filter-item"
              @click="retrieveTables"
              >筛选</el-button
            >
            <el-button
              size="small"
              icon="el-icon-refresh"
              class="filter-item"
              @click="reset"
              >重置</el-button
            >
          </div>
        </div>
      </div>
      <div
        style="margin-left: 220px; overflow:auto;margin-right:20px;padding:0px 20px;"
      >
        <h1 class="page_title">战败审核</h1>
        <div class="filter-container">
          <div style="margin-bottom: 10px;">
            <el-radio-group
              size="small"
              v-model="filterType"
              @change="retrieveTables"
            >
              <el-radio-button :label="1">待审核({{ count0 }})</el-radio-button>
              <el-radio-button :label="2">完成审核</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <el-table :data="tableRecords" stripe v-loading="listLoading">
          <el-table-column align="left" label="跟进时间" width="120">
            <template slot-scope="scope">{{
              scope.row.dateDisplay.split(" ")[1].substring(0, 10)
            }}</template>
          </el-table-column>
          <el-table-column align="left" label="姓名" width="160">
            <template slot-scope="scope">
              <span
                class="click_link"
                @click="toDetailPage(scope.row.customerId)"
              >
                {{ `${scope.row.name}${ scope.row.mobile ? ` - ` : ''}`  }}
                <Desensitize
                  v-if="scope.row.mobile"
                  :text="scope.row.mobile"
                  :userType="2"
                  :clearText="true"
                  :queryKey="scope.row.customerId"
                  :key="scope.row.customerId"
                />
              </span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="客户经理" width="90">
            <template slot-scope="scope">{{ scope.row.ownerName }}</template>
          </el-table-column>
          <el-table-column align="left" label="交叉回访" width="90">
            <template slot-scope="scope">{{
              scope.row.crossRecall ? "是" : "否"
            }}</template>
          </el-table-column>
          <el-table-column align="left" label="最近跟进" min-width="160">
            <template slot-scope="scope">
              <span v-html="scope.row.desc.replaceAll('\n', '<br/>')"></span>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-container">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="listQuery.page"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="listQuery.limit"
            layout="total, sizes, prev, pager, next"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Desensitize from "@/components/Desensitize/Desensitize.vue";
var activity_verify_tasks_vm;
export default {
  components: {
    Desensitize
  },
  data() {
    activity_verify_tasks_vm = this;
    return {
      listLoading: false,
      dealer: this.$common.getDealer(),
      user: this.$common.getUser(),
      isAdmin: this.$common.getAdmin(),
      searchQuery: {
        key: "",
        fromType: 0,
        member: [],
        series: [],
        followDateRange: [
          new Date(new Date().getTime() - 3600 * 1000 * 24 * 6).Format(
            "yyyy-MM-dd"
          ),
          new Date().Format("yyyy-MM-dd"),
        ],
      },
      filterType: 1,

      members: [],
      levelOptions: [],
      businessTypeOptions: [],
      fromSourceOptions: [],
      importSourceOptions: [],
      carOptions: [],

      total: 0,
      listQuery: {
        page: 1,
        limit: 10,
      },

      count0: 0,
      count1: 0,

      tableRecords: [],
    };
  },
  filters: {
    levelDisplay(level) {
      for (var i = 0; i < activity_verify_tasks_vm.levelOptions.length; i++) {
        var o = activity_verify_tasks_vm.levelOptions[i];
        if (o.dataName == level) {
          return o.dataDisplay;
        }
      }
      return "";
    },
    activityTypeDisplay(type) {
      const displayMap = {
        "1": "沟通",
        "2": "到店",
        "3": "试驾",
        "4": "订车",
        "5": "交车",
        "6": "战败",
        "7": "建档",
        "8": "回访",
        "10": "战败复活",
        "21": "新线索分配",
        "22": "新线索清洗",
        "23": "战败审核",
      };
      return displayMap[type + ""];
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path.startWith("/customer/detail/")) {
        try {
          var listFilters = JSON.parse(sessionStorage.getItem("listFilters2"));
          vm.searchQuery = listFilters.searchQuery;
          vm.filterType = listFilters.filterType;
          vm.total = listFilters.total;
          vm.listQuery = listFilters.listQuery;
        } catch (error) {
          console.log(error)
        }
      }
      vm.getList();
      // vm.retrieveTotal();
    });
  },
  created() {
    var baseInfo = this.$common.getBaseInfo();
    this.levelOptions = baseInfo.customerLevels;
    this.businessTypeOptions = baseInfo.businessTypes;
    this.fromSourceOptions = baseInfo.customerFromSources;
    this.importSourceOptions = baseInfo.importSources;

    this.retrieveMembers();
    this.retrieveCarOptions();
    this.retrieveTotal();
  },
  methods: {
    retrieveMembers() {
      var parent = this;
      this.$httpAuth
        .post("/v2/appDealerManagerService/memberList", {
          dealerId: this.dealer.dealerId,
        })
        .then(function(response) {
          parent.members = response.data.data;
          // if (!parent.isAdmin) {
          //   parent.members.push({
          //     memberId: parent.dealer.userId,
          //     userName: parent.dealer.name
          //   });
          // }
        });
    },
    retrieveCarOptions() {
      var parent = this;
      this.$httpAuth
        .post("/v1/dealerRpc/vehicleJsonTree", {
          dealerId: this.dealer.dealerId,
        })
        .then(function(response) {
          parent.carOptions = response.data.data;
        });
    },
    retrieveTotal() {
      this.getActivityTotal(1, "count0");
    },
    getActivityTotal(filterType, column) {
      var parent = this;
      this.$httpAuth
        .post("/v2/appVerifyService/failList", {
          dealerId: this.dealer.dealerId,
          pageStart: (this.listQuery.page - 1) * this.listQuery.limit,
          pageCount: this.listQuery.limit,
          type: this.filterType,
          saleIds: this.searchQuery.member.join(","),
          createdDate: {
            start: "",
            end: "",
          },
          followDate: {
            start: "",
            end: "",
          },
          fromType: this.searchQuery.fromType,
          fromSources: "",
          onlineSources: "",
          businessTypes: "",
          orderType: 0,
          key: this.searchQuery.key,
        })
        .then(function(res) {
          parent[column] = res.data.total
          // if (column != "") {
          //   // eval("parent." + column + "= response.data.total");
          // }
        });
    },
    retrieveTables() {
      this.listQuery.page = 1;
      this.getList();
    },
    getList() {
      var parent = this;
      this.listLoading = true;
      let params = {
        dealerId: this.dealer.dealerId,
        pageStart: (this.listQuery.page - 1) * this.listQuery.limit,
        pageCount: this.listQuery.limit,
        type: this.filterType,
        saleIds: this.searchQuery.member.join(","),
        createdDate: {
          start: "",
          end: "",
        },
        followDate: {
          start: "",
          end: "",
        },
        fromType: this.searchQuery.fromType,
        fromSources: "",
        onlineSources: "",
        businessTypes: "",
        orderType: 0,
        key: this.searchQuery.key,
      };
      if (this.filterType === 2) {
        params.followDate = {
          start:
            this.searchQuery.followDateRange != null
              ? this.searchQuery.followDateRange[0]
              : "",
          end:
            this.searchQuery.followDateRange != null
              ? this.searchQuery.followDateRange[1]
              : "",
        };
      }
      this.$httpAuth
        .post("/v2/appVerifyService/failList", params)
        .then(function(response) {
          parent.listLoading = false;
          parent.tableRecords = response.data.data;
          parent.total = response.data.total;
        });
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    reset() {
      this.searchQuery = {
        key: "",
        fromType: 0,
        member: [],
        series: [],
        followDateRange: [
          new Date(new Date().getTime() - 3600 * 1000 * 24 * 6).Format(
            "yyyy-MM-dd"
          ),
          new Date().Format("yyyy-MM-dd"),
        ],
      };
      this.retrieveTables();
    },
    toDetailPage(id) {
      var listFilters = {
        searchQuery: this.searchQuery,
        filterType: this.filterType,
        total: this.total,
        listQuery: this.listQuery,
      };
      sessionStorage.setItem("listFilters2", JSON.stringify(listFilters));
      this.$router.push({
        path: "/customer/detail/" + id,
      });
    },
  },
};
</script>

<style>
.el-pagination .more + .number {
  display: none !important;
}
</style>
